import React, { useState } from "react";
import { Box, Button, Inline, Text } from "@origin-digital/ods-core";
import {
  mockUserContext,
  useUserContext,
} from "@origin-digital/user-context-provider";
import { getAllPropertiesForUser } from "./utils";
import { PropertySheet } from "./PropertySheet";
import { IconArrowDropDown } from "@origin-digital/ods-icons";

export const PropertySelector = () => {
  const { setProperty, property, user } = useUserContext();

  const [showSheet, setShowSheet] = useState<boolean>();

  // For testing only while API doesn't exist in staging. Can remove later and just use user
  const shouldMockUser = window.oetal?.config?.useMockAppContext;
  const [activeProperties, inactiveProperties] = getAllPropertiesForUser(
    shouldMockUser ? mockUserContext : user
  );

  if (activeProperties) {
    return (
      <Box display="flex" flexDirection="row">
        <Button
          aria-label="Property Selector Button"
          variant="text"
          onClick={() => setShowSheet(true)}
          color="secondaryB"
          size="small"
          data-id="property-selector"
        >
          <Inline alignY="center" space="xsmall" disableWrap={true}>
            <Text
              align="left"
              variant="body-small"
              weight="medium"
              tone="neutral"
              truncate={true}
              inline={true}
            >
              {property ? property.label : "ALL PROPERTIES"}
            </Text>
            <IconArrowDropDown size="small" color="neutral" />
          </Inline>
        </Button>
        <PropertySheet
          selectedProperty={property}
          setProperty={setProperty}
          properties={activeProperties}
          inactiveProperties={inactiveProperties}
          open={showSheet}
          setOpen={setShowSheet}
        />
      </Box>
    );
  }
  return <></>;
};
